export default {
  httpApi: ['//localhost:4001'],
  appSettings: {
    tus: true,
    tusd: false,
    chunkSize: 10 * 1024 * 1024,
    parallelUploads: 5,
    endpoint: '//localhost:4001/api/0/tus'
  },
  imageServer: '//localhost:3300',
  websocket: {
    url: 'ws://localhost:8080/sockjs',
    api: '',
    pingInterval: 50 * 1000,
    maxPingInterval: 2 * 60 * 1000,
    maxWaitingForcePing: 5 * 1000
  }
};
